<template>
  <div>
    <section>
      <TippCard
        hintID="Terminplanung_Archiv_1_V1"
        text="Im Archiv können vergangene Veranstaltungen mit allen Details, Rückmeldungen und veranstaltungsbezogenen Informationen eingesehen werden. Abfragen können dabei auf einen bestimmten Zeitraum begrenzt werden."
      >
      </TippCard>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader icon="mdi-archive" title="Vergangene Veranstaltungen">
              </Subheader>
              <div class="mt-7">
                <v-card :loading="loading">
                  <v-card-text>
                    <v-container fluid class="mb-n10">
                      <v-form
                        @submit.prevent="startQuery"
                        v-model="formIsValid"
                        ref="form"
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="3">
                            <v-text-field
                              v-model="query.range.start"
                              type="date"
                              label="Startdatum"
                              hint="DD.MM.YYYY"
                              outlined
                              :disabled="loading"
                              clearable
                              prepend-inner-icon="mdi-calendar-start"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="3">
                            <v-text-field
                              v-model="query.range.end"
                              type="date"
                              label="Enddatum"
                              hint="DD.MM.YYYY"
                              outlined
                              :rules="[rules.required]"
                              required
                              :disabled="loading"
                              prepend-inner-icon="mdi-calendar-end"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-select
                              v-model="query.status"
                              :items="statusValues"
                              label="Veranstaltungsstatus"
                              outlined
                              multiple
                              required
                              item-text="status"
                              item-value="value"
                              :disabled="loading"
                              prepend-inner-icon="mdi-list-status"
                              hide-details="auto"
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                  :color="statusColor(data.item.value)"
                                  :class="[
                                    'mr-1',
                                    statusTextClass(data.item.value),
                                    'text--darken-4',
                                  ]"
                                  small
                                  @click="toggle"
                                  ><v-icon left small>{{
                                    data.item.icon
                                  }}</v-icon
                                  >{{ data.item.status }}</v-chip
                                >
                              </template>
                            </v-select></v-col
                          >
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      color="success"
                      :disabled="loading"
                      @click="startQuery()"
                      class="mr-5"
                      >Abfrage starten</v-btn
                    >
                  </v-card-actions>
                </v-card>
                <!-- <v-expansion-panels class="mt-6">
                  <v-expansion-panel disabled>
                    <v-expansion-panel-header>
                      <template v-slot:default="{}">
                        <v-row no-gutters>
                          <v-col cols="4">
                            Weitere Filteroptionen<v-chip
                              small
                              label
                              class="ml-2"
                              >Demnächst verfügbar</v-chip
                            ></v-col
                          >
                        </v-row>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content> -->
                <!-- <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-select
                            v-model="query.groups"
                            :items="userGroups"
                            label="Benutzergruppe"
                            outlined
                            multiple
                            required
                            item-text="title"
                            item-value="id"
                            :disabled="loading"
                            prepend-inner-icon="mdi-account-multiple"
                            hide-details="auto"
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index < 2" small>
                                <span>{{ item.title }}</span>
                              </v-chip>
                              <span
                                v-if="index === 2"
                                class="grey--text text-caption"
                              >
                                (+{{ query.groups.length - 2 }} weitere)
                              </span>
                            </template></v-select
                          ></v-col
                        >
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete
                            v-model="query.types"
                            :items="eventTypes"
                            label="Veranstaltungsart"
                            outlined
                            required
                            multiple
                            item-text="title"
                            item-value="meta.id"
                            :disabled="loading"
                            prepend-inner-icon="mdi-format-list-bulleted-type"
                            hide-details="auto"
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index < 2" small>
                                <span>{{ item.title }}</span>
                              </v-chip>
                              <span
                                v-if="index === 2"
                                class="grey--text text-caption"
                              >
                                (+{{ query.types.length - 2 }} weitere)
                              </span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row> -->
                <!-- </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels> -->
              </div>
              <div class="mt-7">
                <v-data-table
                  :headers="headers"
                  :items="archiveMatched"
                  item-key="meta.id"
                  multi-sort
                  sort-by="duration.start.firebaseFormat"
                  :sort-desc="true"
                  :group-by.sync="groupBy"
                  :group-desc.sync="groupDesc"
                  :footer-props="footerProps"
                  :items-per-page="25"
                  class="elevation-2"
                  no-data-text="Keine Veranstaltungen in Abfragezeitraum vorhanden"
                  max-height="800px auto"
                >
                  <!-- @click:row="routeDetails" -->
                  <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
                    <th :colspan="headers.length">
                      <v-icon @click="toggle" class="mr-2"
                        >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                      </v-icon>
                      {{ stripPrefix(items[0].groupBy) }}
                      ({{ getCountOfEventsInMonth(items[0].groupBy) }})
                    </th>
                  </template>
                  <template v-slot:[`item.type.title`]="{ item }">
                    <data-chip
                      small
                      :color="item.type.color"
                      :text="item.type.title"
                    >
                    </data-chip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-menu offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon text v-bind="attrs" v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item link @click="routeDetails(item)">
                          <v-list-item-icon>
                            <v-icon dense>mdi-open-in-app</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Veranstaltungsdetails öffnen</v-list-item-title
                          >
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item link @click="routeDetails(item, 'newTab')">
                          <v-list-item-icon>
                            <v-icon dense>mdi-open-in-new</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Veranstaltungsdetails öffnen (in neuem
                            Tab)</v-list-item-title
                          >
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item
                          :disabled="!!item.connectedDutyReportId"
                          link
                          @click="createDutyReport(item)"
                        >
                          <v-list-item-icon>
                            <v-icon dense>mdi-briefcase-plus</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Dienstbericht erfassen</v-list-item-title
                          >
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item
                          :disabled="!item.connectedDutyReportId"
                          link
                          @click="openDutyReport(item.connectedDutyReportId)"
                        >
                          <v-list-item-icon>
                            <v-icon dense>mdi-open-in-app</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Dienstbericht öffnen</v-list-item-title
                          >
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item
                          link
                          :disabled="!item.connectedDutyReportId"
                          @click="
                            openDutyReport(item.connectedDutyReportId, 'newTab')
                          "
                        >
                          <v-list-item-icon>
                            <v-icon dense>mdi-open-in-new</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Dienstbericht öffnen (in neuem
                            Tab)</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:[`item.connectedDutyReportId`]="{ item }">
                    <v-btn
                      v-if="!item.connectedDutyReportId"
                      small
                      depressed
                      :to="{
                        name: 'duty-management-reports-new',
                        params: {
                          organizationId: $route.params.organizationId,
                        },
                        query: {
                          dutyTypeId: item.type.dutyTypeId,
                          eventId: item.meta.id,
                        },
                      }"
                      ><v-icon left>mdi-file-document-plus</v-icon
                      >Erfassen</v-btn
                    >
                  </template>
                  <template
                    v-slot:[`item.duration.start.firebaseFormat`]="{ item }"
                  >
                    {{ item.duration.start.timestamp }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      :color="statusColor(item.status)"
                      :class="[
                        'font-weight-medium',
                        statusTextClass(item.status),
                        'text--darken-4',
                      ]"
                      small
                    >
                      <v-icon left small>{{ statusIcon(item.status) }}</v-icon
                      >{{ statusText(item.status) }}
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <div
                      style="
                        height: 300px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <p class="subtitle-1">
                        Keine Veranstaltungen in diesem Zeitraum vorhanden.
                      </p>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import DataChip from "@/components/_systemwide/DataChip.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import { /*ADMIN,*/ SCHEDULING } from "@/store/modules.js";
import {
  GET_ARCHIVE,
  // GET_USER_GROUPS,
  // GET_EVENT_TYPES,
} from "@/store/action-types.js";

export default {
  name: "scheduling-archive",
  components: {
    Subheader,
    DataChip,
    TippCard,
    SupportTools,
  },
  data() {
    return {
      search: "",
      sortDesc: true,
      sortBy: "title",
      groupBy: "groupBy",
      groupDesc: true,

      // Table Display Settings
      footerProps: {
        "items-per-page-options": [15, 25, 50, -1],
      },

      query: {
        range: {
          start: null,
          end: null,
        },
        status: ["postponed", "canceled", "finished"],
        types: [],
        groups: [],
      },
      formIsValid: false,
      loading: true,

      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },

      headers: [
        { text: "Veranstaltungstitel", value: "title" },
        { text: "Veranstaltungsart", value: "type.title" },
        { text: "Startzeitpunkt", value: "duration.start.firebaseFormat" },
        {
          text: "Endzeitpunkt",
          value: "duration.end.timestamp",
          sortable: false,
        },
        { text: "Ort", value: "location.name" },
        { text: "Status", value: "status" },
        { text: "", value: "actions" },
      ],

      statusValues: [
        {
          icon: "mdi-calendar",
          value: "planned",
          status: "Geplant",
        },
        {
          icon: "mdi-calendar-alert",
          value: "postponed",
          status: "Verschoben",
        },
        {
          icon: "mdi-calendar-remove",
          value: "canceled",
          status: "Abgesagt",
        },
        {
          icon: "mdi-calendar-check",
          value: "finished",
          status: "Abgeschlossen",
        },
      ],
    };
  },
  computed: {
    userGroups() {
      const userGroups = this.$store.state.admin.userGroups.map((obj) => ({
        title: obj.title,
        id: obj.meta.id,
      }));

      userGroups.unshift({
        title: "Alle",
        id: "all",
      });
      return userGroups;
    },
    eventTypes() {
      return this.$store.state.scheduling.eventTypes;
    },
    archive() {
      return this.$store.state.scheduling.archive;
    },
    archiveMatched() {
      const b = this.archive.map((obj) => ({
        ...obj,
        groupBy: this.groupByDateText(obj.duration.start.dateFormat),
      }));
      return b;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [
        { title: "archiveMatched", data: this.archiveMatched },
        { title: "query", data: this.query },
      ];
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.query.range.end = new Date().toISOString().substr(0, 10);
      // this.$store
      //   .dispatch(`${SCHEDULING}${GET_EVENT_TYPES}`, {
      //     organizationId: this.$route.params.organizationId,
      //   })
      //   // .then(() => {
      //   //   return this.$store.dispatch(`${ADMIN}${GET_USER_GROUPS}`, {
      //   //     organizationId: this.$route.params.organizationId,
      //   //   });
      //   // })
      //   // .then(() => {
      //   //   return (this.query.groups = this.userGroups.map((obj) => obj.id));
      //   // })
      //   // .then(() => {
      //   //   return (this.query.types = this.eventTypes.map((obj) => obj.meta.id));
      //   // })
      //   .then(() => {
      //     this.loading = false;
      //   });
      this.loading = false;
    },

    validate() {
      this.$refs.form.validate();
    },
    startQuery() {
      this.validate();
      if (this.formIsValid) {
        if (this.query.range.start == "") {
          this.query.range.start = null;
        }
        this.$store.dispatch(`${SCHEDULING}${GET_ARCHIVE}`, {
          organizationId: this.$route.params.organizationId,
          query: {
            range: {
              start: this.query.range.start,
              end: this.query.range.end,
            },
            // types: this.query.types,
            // groups: this.query.groups,
            status: this.query.status,
          },
        });
      } else {
        alert("Fehler: Es ist ein Enddatum für die Abfrage erforderlich.");
      }
    },
    getCountOfEventsInMonth(monthId) {
      return this.archiveMatched.filter((event) => event.groupBy === monthId)
        .length;
    },
    statusIcon(status) {
      switch (status) {
        case "planned":
          return "mdi-calendar";
        case "postponed":
          return "mdi-calendar-alert";
        case "canceled":
          return "mdi-calendar-remove";
        case "finished":
          return "mdi-calendar-check";
        case "deletion started":
          return "mdi-delete-outline";
        default:
          break;
      }
    },
    statusText(status) {
      switch (status) {
        case "planned":
          return "Geplant";
        case "postponed":
          return "Verschoben";
        case "canceled":
          return "Abgesagt";
        case "finished":
          return "Abgeschlossen";
        case "deletion started":
          return "Löschung gestartet";
        default:
          break;
      }
    },
    statusColor(status) {
      switch (status) {
        case "planned":
          return "blue lighten-4";
        case "postponed":
          return "orange lighten-4";
        case "canceled":
          return "red lighten-4";
        case "finished":
          return "green lighten-4";
        case "deletion started":
          return "red lighten-4";
        default:
          break;
      }
    },
    statusTextClass(status) {
      switch (status) {
        case "planned":
          return "blue--text";
        case "postponed":
          return "orange--text";
        case "canceled":
          return "red--text";
        case "finished":
          return "green--text";
        case "deletion started":
          return "red--text";
        default:
          break;
      }
    },
    updatePagination(page) {
      console.log(page);
    },
    groupByDateText(date) {
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const monthLong = date.toLocaleString("de-DE", { month: "long" });
      return year + "-" + month + "_" + monthLong + " " + year;
    },
    stripPrefix(item) {
      return item.substring(item.indexOf("_") + 1);
    },
    routeDetails(item, type = "default") {
      if (type === "newTab") {
        window.open(
          this.$router.resolve({
            name: "scheduling-event-details-tab-general",
            params: {
              organizationId: this.$route.params.organizationId,
              itemId: item.meta.id,
            },
          }).href,
          "_blank",
        );
        return;
      } else {
        this.$router.push({
          name: "scheduling-event-details-tab-general",
          params: {
            organizationId: this.$route.params.organizationId,
            itemId: item.meta.id,
          },
        });
      }
    },
    createDutyReport(item) {
      const query = { eventId: item.meta.id };
      if (item.type && item.type.dutyTypeId) {
        query.dutyTypeId = item.type.dutyTypeId;
      }
      this.$router.push({
        name: "duty-management-reports-new",
        params: {
          organizationId: this.$route.params.organizationId,
        },
        query,
      });
    },
    openDutyReport(dutyReportId, type = "default") {
      if (type === "newTab") {
        window.open(
          this.$router.resolve({
            name: "duty-management-reports-details",
            params: {
              organizationId: this.$route.params.organizationId,
              itemId: dutyReportId,
            },
          }).href,
          "_blank",
        );
        return;
      } else {
        this.$router.push({
          name: "duty-management-reports-details",
          params: {
            organizationId: this.$route.params.organizationId,
            itemId: dutyReportId,
          },
        });
      }
    },
  },
};
</script>

<style></style>
